module.exports = __webpack_public_path__ + "media/images/icons/hlukovaMapa-1aafe16e9e2c45115be87f645cd084fe.svg";